<template>
  <div class="contenta">
    <el-container>
      <el-header class="header_w">
        <div class="header">
          <div class="header-logo">
            <img class="img" :src="wzDetail.logo" @click="reload" alt="" />
            <!-- <img class="img" :src="require(`@/assets/img/title_icon.png`)" @click="reload" alt="" /> -->
            <!-- <el-image @click="reload" class="img" :src="wzDetail.logo || ''" alt="" fit="cover" /> -->
            <el-image @click="reload" class="img img-right" :src="require(`@/assets/img/title_icon.png`)" alt="" fit="cover" />
          </div>
          <div class="header-nav">
            <el-menu @select="handleSelect" :default-active="getMenuDefaultActive" mode="horizontal" backgroundColor="transparent" text-color="#999" active-text-color="#fff" :router="false" menu-trigger="hover">
              <template v-for="(ele, index) in menuRouter">
                <el-menu-item v-if="!ele.child_info || !ele.child_info.length" :key="index" :index="String(index)">
                  <span v-if="ele.type === '1'" class="outside">{{ ele.name || "" }}</span>
                  <span v-else>{{ ele.name || "" }}</span>
                </el-menu-item>
                <el-submenu v-else :key="index" :index="String(index)">
                  <template slot="title">
                    <span>{{ ele.name || "" }}</span>
                  </template>
                  <el-menu-item v-for="(item, ind) in ele.child_info" :key="ind" :index="`${index}-${ind}`">{{ item.name || "" }}</el-menu-item>
                </el-submenu>
              </template>
            </el-menu>
            <div v-if="login == 1" class="login-text" @click="getLogin">登录/注册</div>
          </div>
          <div v-if="!isFinalizePage || facility == 'pc'" class="phone_menu">
            <van-popover get-container="phone_menu" v-model="showPopover" trigger="click" theme="dark" :offset="[-10, 8]">
              <div class="phone_menu-item" v-for="(item, index) in menuRouter" :key="index + '1'" :class="phoneMenuActive == index ? 'phone_menu-item-active' : ''
                " @click="handlePopover(item, index)">
                {{ item.name }}
              </div>
              <div v-if="login == 1" class="phone_menu-item" @click="getLogin">
                登录
              </div>
              <template #reference>
                <img src="../assets/img/menu.png" alt="" />
              </template>
            </van-popover>
          </div>
        </div>
      </el-header>
      <el-main :class="{ active: $route.path == '/vac' || $route.path == '/dishonesty' || $route.path == '/record' || $route.path == '/news' || $route.path.indexOf(`/newsdetail`) != -1 }" class="middle">
        <Login v-show="loginShow == 1" />
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>
      <el-footer v-if="!isFinalizePage || facility == 'pc'">
        <!-- 底部页脚 -->
        <div class="footer">
          <div class="footer_body">
            <div class="footer_top">
              <div>
                <a v-for="(item, index) in wzDetail.links" :key="index + '2'" :href="item.url" target="_blank">
                  {{ item.name }}</a>
                <!-- <span @click="ex">清除缓存</span>
                <div class="m40">网站首页</div>
                <div>一键作图</div> -->
              </div>
              <div class="footer_contact">
                <a :href="'tencent://message/?uin=' +
                  wzDetail.contact +
                  '&Site=Sambow&Menu=yes'
                  " target="_blank">
                  客服QQ： {{ wzDetail.contact }}
                </a>
                &nbsp;&nbsp;&nbsp;
                <a :href="'mailto:' + wzDetail.tel" target="_blank">
                  客服邮箱：{{ wzDetail.tel }}
                </a>
              </div>
            </div>
            <div class="footer_bottom">
              <div>
                <p>{{ wzDetail.copyright }}</p>
                <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">
                  {{ wzDetail.case }}
                </a>
                <!-- <p></p> -->
              </div>
              <div>
                <img v-for="(item, index) in wzDetail.bottoms" :key="index + '3'" :class="'footer_bottom_img' + index + 1" :src="item.pic_image" alt="" />
              </div>
            </div>
          </div>
        </div>
      </el-footer>
    </el-container>
    <noticeDialog ref="noticeDialog" @close="stopNotice"></noticeDialog>
    <!-- 头部 -->
  </div>
</template>

<script>
import Login from "@/components/login.vue";
import noticeDialog from "@/components/noticeDialog/index.vue";
import { set, get, isPCMobile } from "../utils/tools";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  components: {
    Login,
    noticeDialog,
  },
  data () {
    return {
      wzDetail: {}, //网站信息
      navData: {
        active: "/home",
        data: [],
        outside: [],
        inside: [],
      },
      showPopover: false,
      phoneMenuActive: 0,
      dropdownData: [],
      totalNoticeList: [], // 通知弹框消息队列
      // timeoutFn: null, // 定时任务
      timeoutShowFn: null, // 定时展示任务

      facility: sessionStorage.getItem("facility"),
      isFinalizePage: false, // 是否是定稿页面
    };
  },
  created () {
    // let currentDan = isPCMobile() ? "mobile" : "pc", path = this.$route.path;
    // let pcRouterList = ["/", "/ranking", "/help", "/blacklist", "/dishonesty", "/news", "/newsdetail", "/personCenter"],
    //   mobileRouterList = ["/mobile", "/mobile/ranking", "/mobile/help", "/mobile/blacklist", "/mobile/dishonesty", "/mobile/news", "/mobile/newsdetail", "/mobile/personal"];
    // if (currentDan == "mobile") {
    //   sessionStorage.setItem("facility", "mobile");
    //   let findIndex = pcRouterList.findIndex(ele => ele == path);
    //   if (findIndex != -1 && path != mobileRouterList[findIndex]) {
    //     this.$router.replace(mobileRouterList[findIndex]);
    //   }
    // } else {
    //   sessionStorage.setItem("facility", "pc");
    //   let findIndex = mobileRouterList.findIndex(ele => ele == path);
    //   if (findIndex != -1 && path != pcRouterList[findIndex]) {
    //     this.$router.replace(pcRouterList[findIndex]);
    //   }
    //   if (findIndex == -1 && path.indexOf(mobileRouterList[7]) != -1) {
    //     this.$router.replace("/personCenter");
    //   }
    // }
    let nav = sessionStorage.getItem("nav");
    if (nav && nav.type == 2) {
      this.navData.active = nav;
    }
    this.getMenu();
    this.getBannerInfo();
  },
  computed: {
    ...mapState(["menuRouter", "login", "loginShow"]),
    ...mapGetters(["getGlobalmMetaInfo"]),
    getMenuDefaultActive () {
      let menuRouter = this.menuRouter;
      let findIndex = menuRouter.findIndex((ele, index) => ele.url == this.$route.path);
      if (findIndex != -1) {
        return String(findIndex);
      }
    },
  },
  watch: {
    "getGlobalmMetaInfo.favicon": function (val) {
      if (val) {
        this.setFavicon(val);
      }
    },
    '$store.state.noticeList': {
      handler: function (val) {
        if (val instanceof Array && val.length != 0) {
          this.totalNoticeList = [...val]
          this.startShowNotice()
        } else {
          this.totalNoticeList = []
          // if(this.$refs.noticeDialog && this.$refs.noticeDialog.showNotice) {
          //   // 如果当前在弹框，则强制关闭
          //   this.$nextTick(() => {
          //     this.$refs.noticeDialog ? this.$refs.noticeDialog.close() : null
          //   })
          // }
        }
      },
      deep: true,
      immediate: true
    },
    $route: {
      handler: function (route) {
        this.isFinalizePage = route.path == "/finalize" ? true : false;
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    ...mapMutations(["setGlobalmMetaInfo"]),
    startShowNotice () {
      if (this.totalNoticeList.length > 0) {
        let item = this.totalNoticeList.shift()
        // if(this.timeoutFn) {
        //   clearTimeout(this.timeoutFn)
        //   this.timeoutFn = null
        // }
        if (this.timeoutShowFn) {
          clearTimeout(this.timeoutShowFn)
          this.timeoutShowFn = null
        }
        this.timeoutShowFn = setTimeout(() => {
          // 避免和1s动画相重合
          this.$refs.noticeDialog ? this.$refs.noticeDialog.show(item) : null
        }, 1000)
        // // 显示五分钟
        // this.timeoutFn = setTimeout(() => {
        //   this.$refs.noticeDialog ? this.$refs.noticeDialog.close() : null
        // }, 301000)
      }
    },
    stopNotice () {
      // if(this.timeoutFn) {
      //   clearTimeout(this.timeoutFn)
      //   this.timeoutFn = null
      // }
      this.$store.commit("setNoticeList", this.totalNoticeList)
    },
    logout () {
      this.$store.dispatch("logout").then(() => {
        // this.$router.replace()
      });
    },
    ex () {
      this.$store.commit("setTime", 0);
      this.$store.commit("setLogin", 1);
      this.$store.commit("setLoginShow", 0);
      this.$store.commit("setMenuRoutes", []);
      this.$store.commit("setUserInfo", "");
      this.$store.commit("setToken", "");

      this.$router.replace({ path: "/" });

      setTimeout(() => {
        location.reload(false);
      }, 150);
    },
    // 菜单
    handleSelect (key, keyPath) {
      let menuRouter = this.menuRouter;
      if (key.indexOf("-") === -1) {
        let findIndex = menuRouter.findIndex((ele, index) => index == key);
        if (findIndex != -1) {
          let url = menuRouter[findIndex].url;
          if (menuRouter[findIndex].type == 1) {
            window.open(url, "_blank");
          } else {
            // location.href = url;
            if (url != this.$route.path)
              this.$router.push(url);
          }
        }
      } else {
        let splitArr = key.split("-");
        let menuRouterObj = menuRouter[splitArr[0]].child_info[splitArr[1]];
        let url = menuRouterObj.url;
        if (menuRouterObj.type == 1) {
          window.open(url, "_blank");
        } else {
          // location.href = url;
          if (url != this.$route.path)
            this.$router.push(url);
        }
      }
    },
    // 导航
    getMenu () {
      let _this = this;
      let param = {
        substation_id: set(_this.config.substationId),
      };
      _this.$indexPost("/getMenu", param).then((res) => {
        _this.dropdownData = res;
        _this.navData.outside = res.filter((item) => item.type == "1");
        _this.navData.data = res;
        if (
          _this.menuRouter &&
          _this.menuRouter.length > 0 &&
          _this.login == 0
        ) {
          _this.$store.commit("setMenuRoutes", res);
          _this.$store.commit("addMenuRoutes", {
            id: 99,
            name: "个人中心",
            url: "/personCenter",
            type: "2",
            weigh: 4,
            createtime: "2022-10-20 16:59",
            hid: 0,
          });
        } else {
          _this.$store.commit("setMenuRoutes", res);
        }
      });
    },
    // 获取MenuItem的index
    getMenuItemIndex (item) {
      if (item.type === "1") return "";
      // return item.hid ? `${item.url}/${item.hid}` : item.url;
      return item.url;
    },
    // 下拉菜单
    handlePopover (item, index) {
      this.showPopover = false;
      // console.log(item,"下拉菜单");
      // if (item.type == "2" && item.hid) {
      //   this.phoneMenuActive = index;
      //   this.$router.push({ path: item.url, query: { id: item.hid } });
      // }
      // if (item.type == "2" && !item.hid) {
      //   this.phoneMenuActive = index;
      //   this.$router.push({ path: item.url });
      // }
      if (item.type == "2") {
        // location.href = item.url;
        if (item.url != this.$route.path)
          this.$router.push({ path: item.url });
      }
      if (item.type == "1") {
        window.open(item.url);
      }
      // console.log(command,"command");
    },
    // 获取网站信息
    getBannerInfo () {
      let _this = this;
      let param = {
        substation_id: set(_this.config.substationId),
      };
      _this
        .$indexPost("/getBanner", param)
        .then((res) => {
          // 网站配置信息
          _this.wzDetail = res;
          _this.logo = res.logo;
          this.setGlobalmMetaInfo({
            name: res.name,
            favicon: res.favicon,
          });
          _this.$store.commit('setOrderTypes', res.order)
        })
        .catch((err) => { });
    },
    // 刷新
    reload () {
      // window.location.replace("/");
      if (this.$route.path != "/") {
        this.$router.push("/");
      }
    },
    // 登录/个人中心
    getLogin () {
      this.$store.commit("setLoginShow", 1);
    },
    // 设置网站的favicon
    setFavicon (iconUrl) {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = iconUrl;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
  },
};
</script>

<style scoped lang="scss">
.login-text {
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  color: #2c9645;
  vertical-align: baseline;

  &:hover {
    color: #fff;
  }
}

.contenta {
  width: 100%;
  background: rgba(255, 255, 255, 0.12);
  // position: relative;
}

// 导航
.header_w {
  width: 100vw;
  position: fixed;
  top: 0px;
  z-index: 99;

  .header {
    max-width: 1260px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }

  .header-logo {
    display: flex;
    align-items: center;

    .img {
      flex: 0 0 110px;
      width: 110px;
      cursor: pointer;
      object-fit: cover;
    }

    .img-right {
      flex: 0 0 75px;
      width: 75px;
      height: 40px;
      margin-left: 10px;
    }
  }

  ::v-deep .van-popover__content {
    padding: 10px 0;
  }

  .phone_menu-item {
    width: 90px;
    text-align: center;
    font-size: 20px;
    line-height: 1.8;
    padding: 0 8px;
    color: #999;
    // padding-bottom: 12px;
  }

  .phone_menu-item-active {
    color: #fff;
  }

  .header-nav {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Source Code Pro, Source Code Pro-Regular;
    font-weight: 400;
    text-align: LEFT;

    .outside {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        top: -20px;
        right: -20px;
        bottom: -20px;
        left: -20px;
      }
    }
  }
}

.middle {

  &.active {
    background: url("@/assets/img/vac.png") #171616;
    background-repeat: no-repeat;
    background-size: 100%;
  }
}

// 页脚
.footer {
  background: #49494f;
  width: 100%;

  // box-sizing: border-box;
  a {
    color: #ffffff;
    text-decoration: none;
    margin-right: 20px;

    &:hover {
      color: #ff5959;
      text-decoration: underline;
    }
  }

  .footer_body {
    margin: 0 auto;

    .footer_top {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      color: #ffffff;

      >div {
        display: flex;
        align-items: center;
      }

      // a{
      //   color: #ffffff;
      //   text-decoration: none;
      //   margin-right: 20px;
      //   &:hover{
      //     color: #ff5959;
      //     text-decoration: underline;
      //   }
      // }
    }

    .footer_bottom {
      display: flex;
      // align-items: center;
      justify-content: space-between;
      padding: 20px 0;

      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.7);

      >div {
        p {
          // font-size: 12px;
          line-height: 2;
          color: rgba(250, 250, 250, 0.7);
        }

        a {
          color: rgba(250, 250, 250, 0.7);
        }

        img {
          vertical-align: middle;
        }

        // padding: ;
        // display: flex;
      }
    }
  }
}

@media only screen and (min-width: 901px) {
  .middle {
    min-height: calc(100vh - 140px);
  }

  .content {
    width: 100%;
    // overflow-x: hidden;
  }

  .phone_menu {
    display: none;
  }

  .header_w {
    height: 56px;
    background: linear-gradient(180deg,
        #020911,
        rgba(3, 10, 19, 0.15) 100%,
        rgba(3, 11, 20, 0) 100%);
  }

  .footer_body {
    width: 62%;

    .footer_top {
      font-size: 12px;
      font-weight: 400;
      padding-top: 24px;
      padding-bottom: 20px;
    }

    .footer_bottom {
      p {
        font-size: 12px;
      }

      img {
        margin-right: 20px;
        max-width: 28px;
        height: 24px;

        &:last-child {
          max-width: 114px;
          height: 40px;
        }
      }
    }
  }
}

@media screen and (min-width: 310px) and (max-width: 900px) {
  .middle {
    min-height: calc(100vh - 100px);
  }

  .contenta {
    padding-bottom: 100px;
    background-color: #000;
    box-sizing: border-box;
  }

  .header_w,
  .header {
    background: none;
  }

  .header-nav {
    display: none !important;
  }

  .phone_menu {
    width: 46px;
    height: 47px;
    display: inline-block;

    img {
      width: 100%;
    }
  }

  .header {
    padding: 0 24px;
  }

  .footer_body {
    width: 90%;

    .footer_top {
      width: 100%;
      flex-wrap: wrap;
      // justify-content: center !important;
      font-size: 10px;
      font-weight: 400;
      padding-top: 24px;
      padding-bottom: 20px;
    }

    .footer_bottom {
      width: 100%;
      flex-wrap: wrap;

      p {
        font-size: 8px;
      }

      img {
        margin-right: 20px;
        max-width: 24px;
        height: 22px;

        &:last-child {
          max-width: 100px;
          height: 36px;
        }
      }

      a {
        font-size: 20px;
      }

      // justify-content: center !important;
    }
  }
}
</style>
